module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin18-454e9f2e3094144d0162c82b505304a3.jpg";